import {AxiosInstance} from "axios";
import {createStreamingAdapter} from "@/core/http/streaming";
import {Knowledgeable, KnowledgeableProduct} from "@/knowledge-box/interfaces";

interface KnowledgableIndexQueryParams {
    knowledgeable_types?: (string | null)[];
}

export default function (client: AxiosInstance) {

    return {
        /**
         * Index all knowledgeables.
         *
         * @param query
         */
        async index(query: KnowledgableIndexQueryParams = {}): Promise<Knowledgeable[]> {
            return client.get('knowledgeables', {params: query})
                .then(response => response.data.data);
        },

        /**
         * Ask knowledge box and stream the response.
         *
         * Use a custom streaming adapter to handle server-sent events (SSE).
         */
        async streamKnowledgeBox(
            knowledgeableId: number,
            question: string,
            onChunk: (chunk: string) => void,
            onError: (error: any) => void,
            abortController?: AbortController
        ) {
            try {
                await client({
                    method: "POST",
                    url: `knowledgeables/${knowledgeableId}`,
                    data: {
                        prompt: question
                    },
                    headers: {
                        'Accept': 'text/event-stream',
                    },
                    adapter: createStreamingAdapter(onChunk, onError),
                    signal: abortController?.signal
                });
            } catch (error) {
                if (onError) {
                    onError(error);
                }
            }
        },

        async extractProducts(knowledgableId: number, prompt: string, abortController: AbortController | null = null): Promise<KnowledgeableProduct[]> {
            return client.post(`knowledgeables/${knowledgableId}/products`, {
                prompt
            }, {
                signal: abortController?.signal
            }).then((response) => {
                return response.data.data;
            });
        }
    };
}
